import React from 'react'

import { OTA_TICKET_TYPES } from '@/constants/ticketTypes'
import { useTicketFiltersContext } from '@/context/filters/ticketFilters/ticketFilters'
import useOtaTicketSection from '@/hooks/useDashboard/useOtaTicketSection'
import { useGuardedNavigate } from '@/hooks/useGuardedNavigate'
import { Status } from '@/types/Ticket'

import { Card } from './Card'
import LoadingSkeleton from './LoadingSkeleton'

const OtaTickets = () => {
  const otaTicketQuery = useOtaTicketSection()
  const ticketData = otaTicketQuery?.data?.agmDashboard
  const { setFilters } = useTicketFiltersContext()
  const navigate = useGuardedNavigate()

  // Helper to set OTA ticket type filters for all navigation handlers
  const setOtaFiltersAndNavigate = (statuses: Status[], ticketReasons?: string[]) => {
    setFilters({
      ticketTypes: [...OTA_TICKET_TYPES],
      ticketReasons: ticketReasons ?? undefined,
      ticketStatuses: statuses,
      startingCreatedAtDate: undefined,
      endingCreatedAtDate: undefined,
    })
    navigate('/tickets')
  }

  const handleOpenTickets = () => {
    setOtaFiltersAndNavigate([Status.NEW, Status.WORKING, Status.NEEDS_ACTION, Status.AWAITING_RESPONSE])
  }

  const handleNewTickets = () => {
    setOtaFiltersAndNavigate([Status.NEW])
  }

  const handleNeedsActionTickets = () => {
    setOtaFiltersAndNavigate([Status.NEEDS_ACTION])
  }

  const handleAwaitingResponseTickets = () => {
    setOtaFiltersAndNavigate([Status.AWAITING_RESPONSE])
  }

  return (
    <>
      <h2 className="my-4 text-xl">OTA Tickets</h2>
      <div className="grid grid-cols-4 grid-rows-1 place-items-stretch gap-3 md:gap-6">
        {otaTicketQuery?.isLoading ? (
          <LoadingSkeleton />
        ) : (
          <>
            <Card label="Open" onClick={handleOpenTickets} value={ticketData?.totalOpenTickets || 0} />
            <Card label="New" onClick={handleNewTickets} value={ticketData?.totalNewTickets || 0} />
            <Card
              label="Needs Action"
              onClick={handleNeedsActionTickets}
              value={ticketData?.totalNeedsActionTickets || 0}
            />
            <Card
              label="Awaiting Response"
              onClick={handleAwaitingResponseTickets}
              value={ticketData?.totalAwaitingResponseTickets || 0}
            />
          </>
        )}
      </div>
    </>
  )
}

export default OtaTickets
